import React, { useState } from 'react';
import { imgErrorFallback } from '../utils/imageUtils';

function NewsEvents() {
  const [activeTab, setActiveTab] = useState('upcoming');

  const upcomingEvents = [
    {date: '10', month: 'Apr', year: '2026', title: 'Results Announcement', desc: 'Annual examination results will be announced. Parents and students are requested to be present.', time: '9:30 AM', venue: 'School Campus', color: '#f59e0b'},
    {date: '01', month: 'Jun', year: '2026', title: 'School Reopens After Summer Vacations', desc: 'School reopens for the new academic year 2026-27. We look forward to welcoming all students back!', time: '8:30 AM', venue: 'School Campus', color: '#10b981'}
  ];

  const recentNews = [
    {date: '07 Mar 2026', title: '10th Graduation Ceremony', desc: 'A proud moment as our Class 10 students celebrated their graduation. Wishing them all the best for their future endeavours!', image: '/images/news-events/event-1.svg', category: 'Event'},
    {date: '06 Mar 2026', title: 'Sharing Day Event', desc: 'Students came together to share and celebrate the joy of giving. A wonderful day of togetherness and community spirit at Bethel!', image: '/images/news-events/event-2.svg', category: 'Event'},
    {date: '14 Feb 2026', title: 'UKG Graduation Ceremony', desc: 'Our little stars of UKG celebrated their graduation day with joy and excitement. A memorable milestone as they move on to primary school!', image: '/images/news-events/event-3.svg', category: 'Event'}
  ];

  return (
    <section style={{background: 'linear-gradient(135deg, #fff7ed 0%, #ffedd5 100%)', minHeight: '100vh', padding: '20px 0 80px 0'}}>
      <div className="container">
        <div style={{textAlign: 'center', marginBottom: '60px'}}>
          <h2 style={{fontSize: '4rem', color: '#7c2d12', fontWeight: 900, marginBottom: '20px'}}>News & Events</h2>
          <p style={{fontSize: '1.4rem', color: '#92400e', maxWidth: '800px', margin: '0 auto'}}>Stay updated with latest happenings at Bethel Public School</p>
        </div>

        {/* Tab Navigation */}
        <div style={{display: 'flex', justifyContent: 'center', gap: '20px', marginBottom: '50px'}}>
          <button
            onClick={() => setActiveTab('upcoming')}
            style={{padding: '15px 40px', borderRadius: '50px', border: 'none', background: activeTab === 'upcoming' ? 'linear-gradient(135deg, #f59e0b 0%, #d97706 100%)' : 'white', color: activeTab === 'upcoming' ? 'white' : '#92400e', fontSize: '1.2rem', fontWeight: 700, cursor: 'pointer', boxShadow: '0 5px 15px rgba(0,0,0,0.1)', transition: 'all 0.3s'}}
            onMouseEnter={(e) => e.target.style.transform = 'translateY(-3px)'}
            onMouseLeave={(e) => e.target.style.transform = 'translateY(0)'}
          >
            <i className="fas fa-calendar-alt" style={{marginRight: '10px'}}></i>Upcoming Events
          </button>
          <button
            onClick={() => setActiveTab('recent')}
            style={{padding: '15px 40px', borderRadius: '50px', border: 'none', background: activeTab === 'recent' ? 'linear-gradient(135deg, #f59e0b 0%, #d97706 100%)' : 'white', color: activeTab === 'recent' ? 'white' : '#92400e', fontSize: '1.2rem', fontWeight: 700, cursor: 'pointer', boxShadow: '0 5px 15px rgba(0,0,0,0.1)', transition: 'all 0.3s'}}
            onMouseEnter={(e) => e.target.style.transform = 'translateY(-3px)'}
            onMouseLeave={(e) => e.target.style.transform = 'translateY(0)'}
          >
            <i className="fas fa-newspaper" style={{marginRight: '10px'}}></i>Recent News
          </button>
        </div>

        {/* Upcoming Events */}
        {activeTab === 'upcoming' && (
          <div style={{display: 'flex', flexDirection: 'column', gap: '25px'}}>
            {upcomingEvents.map((event, i) => (
              <div key={i} style={{background: 'white', borderRadius: '20px', padding: '30px', boxShadow: '0 10px 30px rgba(0,0,0,0.1)', display: 'grid', gridTemplateColumns: '120px 1fr', gap: '30px', transition: 'all 0.3s', borderLeft: `5px solid ${event.color}`}}
                onMouseEnter={(e) => e.currentTarget.style.transform = 'translateX(10px)'}
                onMouseLeave={(e) => e.currentTarget.style.transform = 'translateX(0)'}>
                <div style={{textAlign: 'center', background: event.color, borderRadius: '15px', padding: '20px', color: 'white'}}>
                  <div style={{fontSize: '3rem', fontWeight: 900, lineHeight: 1}}>{event.date}</div>
                  <div style={{fontSize: '1.2rem', fontWeight: 600, marginTop: '5px'}}>{event.month}</div>
                  <div style={{fontSize: '0.9rem', opacity: 0.9}}>{event.year}</div>
                </div>
                <div>
                  <h3 style={{fontSize: '1.8rem', color: '#1e293b', marginBottom: '12px', fontWeight: 700}}>{event.title}</h3>
                  <p style={{fontSize: '1.05rem', color: '#64748b', lineHeight: 1.7, marginBottom: '15px'}}>{event.desc}</p>
                  <div style={{display: 'flex', gap: '30px', fontSize: '0.95rem', color: '#94a3b8'}}>
                    <span><i className="fas fa-clock" style={{marginRight: '8px', color: event.color}}></i>{event.time}</span>
                    <span><i className="fas fa-map-marker-alt" style={{marginRight: '8px', color: event.color}}></i>{event.venue}</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}

        {/* Recent News */}
        {activeTab === 'recent' && (
          <div style={{display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(380px, 1fr))', gap: '30px'}}>
            {recentNews.map((news, i) => (
              <div key={i} style={{background: 'white', borderRadius: '20px', overflow: 'hidden', boxShadow: '0 10px 30px rgba(0,0,0,0.1)', transition: 'all 0.3s'}}
                onMouseEnter={(e) => e.currentTarget.style.transform = 'translateY(-10px)'}
                onMouseLeave={(e) => e.currentTarget.style.transform = 'translateY(0)'}>
                <div style={{position: 'relative', overflow: 'hidden', height: '220px'}}>
                  <img src={news.image} alt={news.title} style={{width: '100%', height: '100%', objectFit: 'cover', transition: 'transform 0.5s'}}
                    onMouseEnter={(e) => e.target.style.transform = 'scale(1.1)'}
                    onMouseLeave={(e) => e.target.style.transform = 'scale(1)'} />
                  <div style={{position: 'absolute', top: '15px', right: '15px', background: '#f59e0b', color: 'white', padding: '8px 20px', borderRadius: '20px', fontSize: '0.85rem', fontWeight: 600}}>
                    {news.category}
                  </div>
                </div>
                <div style={{padding: '25px'}}>
                  <div style={{fontSize: '0.9rem', color: '#94a3b8', marginBottom: '10px', display: 'flex', alignItems: 'center', gap: '8px'}}>
                    <i className="fas fa-calendar"></i>{news.date}
                  </div>
                  <h3 style={{fontSize: '1.4rem', color: '#1e293b', marginBottom: '12px', fontWeight: 700, lineHeight: 1.3}}>{news.title}</h3>
                  <p style={{color: '#64748b', fontSize: '1rem', lineHeight: 1.6}}>{news.desc}</p>
                </div>
              </div>
            ))}
          </div>
        )}

        {/* Newsletter Subscription */}
        <div style={{background: 'linear-gradient(135deg, #8b5cf6 0%, #7c3aed 100%)', padding: '50px', borderRadius: '25px', textAlign: 'center', color: 'white', marginTop: '60px', boxShadow: '0 15px 40px rgba(139, 92, 246, 0.3)'}}>
          <i className="fas fa-envelope-open-text" style={{fontSize: '3.5rem', marginBottom: '20px'}}></i>
          <h3 style={{fontSize: '2.2rem', marginBottom: '15px', fontWeight: 800, color: 'white'}}>Stay Connected!</h3>
          <p style={{fontSize: '1.2rem', marginBottom: '30px', opacity: 0.95}}>Subscribe to our newsletter to receive updates about school events, achievements, and important announcements.</p>
          <a
            href="mailto:bethelvijinapura@gmail.com?subject=Newsletter Subscription"
            style={{background: 'white', color: '#8b5cf6', padding: '18px 45px', borderRadius: '50px', textDecoration: 'none', fontWeight: 700, fontSize: '1.2rem', display: 'inline-block', boxShadow: '0 8px 20px rgba(255, 255, 255, 0.3)', transition: 'all 0.3s'}}
            onMouseEnter={(e) => e.target.style.transform = 'translateY(-3px)'}
            onMouseLeave={(e) => e.target.style.transform = 'translateY(0)'}
          >
            <i className="fas fa-bell" style={{marginRight: '10px'}}></i>Subscribe Now
          </a>
        </div>
      </div>
    </section>
  );
}

export default NewsEvents;
